export const licenseRateToInputString = (monthlyRateAmount: number): string => String(monthlyRateAmount)

export type ParseLicenseRateResult = { ok: true; value: number | null } | { ok: false }

export const parseOptionalLicenseRate = (raw: string): ParseLicenseRateResult => {
  const trimmedInput = raw.trim()
  if (trimmedInput === '') return { ok: true, value: null }
  const parsedNumber = Number(trimmedInput.replace(',', '.'))
  if (!Number.isFinite(parsedNumber) || parsedNumber < 0) return { ok: false }
  return { ok: true, value: parsedNumber }
}

export type LicenseRatesInputFields = {
  locality: string
  serviceStation: string
  storage: string
}

export type ParsedLicenseRatesBody = {
  licenseLocalityMonthlyRate: number | null | undefined
  licenseServiceStationMonthlyRate: number | null | undefined
  licenseStorageMonthlyRate: number | null | undefined
}

export const parseLicenseRatesUpdateBody = (
  isGlobalServiceStationProvider: boolean,
  fields: LicenseRatesInputFields,
): { ok: true; body: ParsedLicenseRatesBody } | { ok: false } => {
  if (isGlobalServiceStationProvider) {
    const serviceStationRateParse = parseOptionalLicenseRate(fields.serviceStation)
    if (!serviceStationRateParse.ok) return { ok: false }
    return {
      ok: true,
      body: {
        licenseLocalityMonthlyRate: null,
        licenseServiceStationMonthlyRate: serviceStationRateParse.value,
        licenseStorageMonthlyRate: null,
      },
    }
  }
  const localityRateParse = parseOptionalLicenseRate(fields.locality)
  const serviceStationRateParse = parseOptionalLicenseRate(fields.serviceStation)
  const storageRateParse = parseOptionalLicenseRate(fields.storage)
  if (!localityRateParse.ok || !serviceStationRateParse.ok || !storageRateParse.ok) return { ok: false }
  return {
    ok: true,
    body: {
      licenseLocalityMonthlyRate: localityRateParse.value,
      licenseServiceStationMonthlyRate: serviceStationRateParse.value,
      licenseStorageMonthlyRate: storageRateParse.value,
    },
  }
}
